// extracted by mini-css-extract-plugin
export default {"-large":"kK0RDyPxorYUzjwEdcN9","aiBGLight":"KNs6_83Qz6xslBPvTXI3","aiText":"KjxTeJJwcSDnjpzAlusz","pulsatingDotForCopyStyles":"Fuha5lewtUCgwjb6jPq2"};